import BrandingWatermarkIcon from '@material-ui/icons/BrandingWatermark'
import BrandingEdit from './BrandingEdit'

const branding = () => ({
  icon: BrandingWatermarkIcon,
  list: BrandingEdit,
  name: 'branding',
})

export default branding
